import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const SearchIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "search",
  "SearchIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M7.33337 0.666992C4.01967 0.666992 1.33337 3.35328 1.33337 6.66699C1.33337 9.9807 4.01967 12.667 7.33337 12.667C8.75005 12.667 10.0521 12.176 11.0785 11.3549L14 14.2765L14.9428 13.3337L12.0213 10.4121C12.8424 9.38567 13.3334 8.08367 13.3334 6.66699C13.3334 3.35328 10.6471 0.666992 7.33337 0.666992ZM2.66671 6.66699C2.66671 4.08966 4.75605 2.00033 7.33337 2.00033C9.9107 2.00033 12 4.08966 12 6.66699C12 9.24432 9.9107 11.3337 7.33337 11.3337C4.75605 11.3337 2.66671 9.24432 2.66671 6.66699Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default SearchIcon;
